import Component from './Component.js'
import {define, Renderer, setRenderer} from './runtime.js'

export {
  Component,
  define,
  Renderer,
  setRenderer,
}
